import Image from 'next/image';
import styled from '@emotion/styled';

export const Container = styled.div``;
export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 1440px;
  width: 100%;
`;
export const Section = styled.section`
  padding: 24px;
  background-color: #fff;
  border-radius: 24px;
`;
export const Title = styled.h2`
  padding: 44px 0 0 30px;
  color: #121212;
  font-size: 32px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.6px;
`;
export const SubTitle = styled.h3`
  padding: 0 0 44px 30px;
  color: #121212;
  font-size: 22px;
  font-weight: 500;
  line-height: 34px;
`;
export const SolutionList = styled.ul``;
export const Solution = styled.li`
  display: flex;
  align-items: center;
  height: 80px;
  width: 100%;
  border-top: 1px solid #e5e7eb;
`;
export const Label = styled.span`
  padding-left: 30px;
  display: inline-block;
  min-width: 30%;

  color: #121212;
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
`;
export const Value = styled.span`
  padding: 0 180px 0 150px;
  display: flex;
  justify-content: center;

  width: 70%;
  min-width: 367px;
  color: #121212;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 26px;
  white-space: pre;
`;

export const CheckValue = styled.p`
  position: relative;
  padding: 0 180px 0 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;

  &::before {
    content: '';
    position: absolute;
    width: 32px;
    height: 32px;
    background-color: #3449ff;
    border-radius: 99%;
    z-index: 0;
  }
`;
export const CheckImage = styled(Image)`
  position: relative;
  z-index: 1;
`;
export const DescriptionWrap = styled.div`
  padding: 16px 30px;
  background-color: #f9fafb;
`;
export const Description = styled.p`
  position: relative;
  padding-left: 20px;
  color: #121212;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.007px;

  &::before {
    content: '•';
    position: absolute;
    top: 0;
    left: 8px;
    width: 4px;
    height: 4px;
  }
`;
